module.exports = __webpack_public_path__ + "img/service_img2.b42a1b0b.png";